import api, { setToken, clearToken } from "./client";

const AUTH_BASE = "/auth";

function unwrapAuthPayload(result) {
  const payload =
    result?.data && typeof result.data === "object"
      ? result.data
      : result || {};

  const user =
    payload.user ||
    payload.account ||
    payload.profile ||
    payload.current_user ||
    payload.me ||
    {};

  const accessToken =
    payload.access_token ||
    payload.accessToken ||
    payload.token ||
    payload.jwt ||
    payload?.auth?.access_token ||
    payload?.session?.access_token ||
    null;

  const refreshToken =
    payload.refresh_token ||
    payload.refreshToken ||
    payload?.auth?.refresh_token ||
    payload?.session?.refresh_token ||
    null;

  const refreshTokenExpiresAt =
    payload.refresh_token_expires_at ||
    payload.refreshTokenExpiresAt ||
    payload?.auth?.refresh_token_expires_at ||
    payload?.session?.refresh_token_expires_at ||
    null;

  return {
    ...payload,
    ...(user && typeof user === "object" ? user : {}),
    user,
    access_token: accessToken,
    refresh_token: refreshToken,
    refresh_token_expires_at: refreshTokenExpiresAt,
  };
}

export async function login(email, password, mfaCode, extra = {}) {
  try {
    const result = await api.post(
      `${AUTH_BASE}/login`,
      {
        email,
        password,
        ...(mfaCode ? { mfa_code: mfaCode } : {}),
        ...(extra && typeof extra === "object" ? extra : {}),
      },
      { retries: 0 }
    );

    const payload = unwrapAuthPayload(result);

    if (payload?.access_token) {
      setToken(payload.access_token);
    }

    return payload;
  } catch (err) {
    console.error("Login failed:", err);
    throw err?.response?.data || err?.data || { message: "Login failed" };
  }
}

export async function register(data) {
  try {
    const result = await api.post(
      `${AUTH_BASE}/register`,
      data,
      { retries: 0 }
    );

    const payload = unwrapAuthPayload(result);

    if (payload?.access_token) {
      setToken(payload.access_token);
    }

    return payload;
  } catch (err) {
    console.error("Register failed:", err);
    throw err?.response?.data || err?.data || { message: "Registration failed" };
  }
}

export function me() {
  return api.get(`${AUTH_BASE}/me`, {
    retries: 0,
    suppressRedirectOn401: true,
    redirectOn401: false,
    clearTokenOn401: false,
  });
}

export function logout() {
  clearToken();
}